var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 4.375H3.47266C3.00781 4.375 2.625 4.78516 2.625 5.25C2.625 5.6875 3.00781 6.125 3.47266 6.125H10.4727C10.9648 6.125 11.375 5.74219 11.375 5.25C11.375 4.78516 10.9648 4.375 10.5 4.375ZM7.875 8.75H6.09766C5.63281 8.75 5.25 9.16016 5.25 9.625C5.25 10.0625 5.63281 10.5 6.09766 10.5H7.84766C8.33984 10.5 8.75 10.1172 8.75 9.625C8.75 9.16016 8.33984 8.75 7.875 8.75ZM12.25 0H1.72266C1.25781 0 0.875 0.410156 0.875 0.875C0.875 1.3125 1.25781 1.75 1.72266 1.75H12.2227C12.7148 1.75 13.125 1.36719 13.125 0.875C13.125 0.410156 12.7148 0 12.25 0Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.a034d5ab21a6544fb23cfe818d29765b.svg";
export { ForwardRef as ReactComponent };